export default "__VITE_ASSET__SeF4efCT__"